namespace Matrix.Workflow {
    export class ClientFunctionTriggerParametersColumns {
        static columnsKey = 'Workflow.ClientFunctionTriggerParameters';
    }
}
